import React from 'react';
import Table from 'react-bootstrap/Table';
import './program-panel.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faClock, faCheckCircle, faExclamationCircle, faUser, faUserTie, faHouseUser } from '@fortawesome/free-solid-svg-icons'; //faPaperPlane
export interface PostProps {
  programData: any[];
}

class ProgramPanel extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {
      programData: this.props.programData,
      exclusionList: ['url', 'playlistButtonSecondaryTitle', 'playlistButtonTitle', 'thumbnailUrl']
    };
  }

  componentDidUpdate(prevProps: PostProps) {
    if (this.props.programData !== prevProps.programData) {
      this.setState({ programData: this.props.programData });
    }
  }

  // --- StateID renderelő ---
  renderStateID = (val: string) => { // Típusbeállítás a val-ra
    switch (val) {
      case '1':
        return <span className="state-approved"><FontAwesomeIcon icon="check-circle" /></span>;
      case '2':
        return <span className="state-comment"><FontAwesomeIcon icon="exclamation-circle" /></span>;
      case '3':
        return <span className="state-reject"><FontAwesomeIcon icon="ban" /></span>;
      default:
        return val;
    }
  }

  // --- UNIVERSAL JSON RENDERER ---
  renderValue = (value: unknown) => {
    if (value === null || value === undefined) return '';

    // STRING / NUMBER
    if (typeof value === 'string' || typeof value === 'number') {
      return value.toString();
    }

    // ARRAY
    if (Array.isArray(value)) {
      return (
        <div className="json-list">
          {value.map((item, i) => (
            // Használjon div-et, hogy az elemek új sorba kerüljenek
            <div key={i} className="json-array-item">
              {this.renderValue(item)}
            </div>
          ))}
        </div>
      );
    }

    // OBJECT
    if (typeof value === 'object') {
      return (
        <div className="json-object">
          {Object.entries(value).map(([key, val], i) => {
            // stateID speciális kezelése
            if (key === 'stateID') {
              return (
                <span key={i} className="state-id">
                  {this.renderStateID(val)}
                </span>
              );
            }
            if (key === 'name') {
              return (
                <span key={i} className="review-name">
                  {this.renderStateID(val)}
                </span>
              );
            }
            if (key === 'date') {
              return (
                <span key={i} className="review-date">
                  {this.renderStateID(val)}
                </span>
              );
            }

            return (
              <span key={i}>
                {this.renderValue(val)}
              </span>
            );
          })}
        </div>
      );
    }

    return String(value);
  };

  render() {
    const { programData, exclusionList } = this.state;
    const programItems = programData.program || [];
    const exclusionSet = new Set(exclusionList);

    // --- ReviewState meghatározás ---
    let reviewState = '';
    const reviewStateItem = programItems.find((item: any) => item.id === 'incoming_reviewState');
    if (reviewStateItem) {
      reviewState = reviewStateItem.data;
    }

    // --- Színezés hozzárendelése ---
    const getRowClassName = (id: string): string => {
      if (id === 'incoming_reviewInfo' && reviewState) {
        switch (reviewState) {
          case '1': return 'state-green';
          case '2': return 'state-yellow';
          case '3': return 'state-red';
          default: return '';
        }
      }
      return '';
    };

    // --- Szétválasztás ---
    const incomingItems = programItems.filter((value: any) =>
      value.data && value.show &&
      !exclusionSet.has(value.id) &&
      value.id.startsWith('incoming_') &&
      value.id !== 'incoming_reviewState'
    );

    const otherItems = programItems.filter((value: any) =>
      value.data && value.show &&
      !exclusionSet.has(value.id) &&
      !value.id.startsWith('incoming_')
    );

    // --- Sor renderelés ---
    const renderRows = (items: any[], keyPrefix: string) => {
      return items.map((value: any, index: number) => (
        <tr key={keyPrefix + index}>
          <td className="table-cell-data">{value.label}</td>
          <td className={getRowClassName(value.id)}>
            {this.renderValue(value.data)}
          </td>
        </tr>
      ));
    };

    return (
      <Table className='table-styled info-table'>
        {/* ---------- Beérkező adatok ---------- */}
        {incomingItems.length > 0 && (
          <>
            <thead>
              <tr>
                <th colSpan={2}><span>Beérkező adatok</span></th>
              </tr>
            </thead>
            <tbody>
              {renderRows(incomingItems, 'incomingLine_')}
            </tbody>
          </>
        )}

        {/* ----------- Egyéb program adatok ----------- */}
        {otherItems.length > 0 && (
          <>
            {incomingItems.length > 0 && <tr><td colSpan={2}></td></tr>}

            <thead>
              <tr>
                <th colSpan={2}><span>Felvétel adatok</span></th>
              </tr>
            </thead>
            <tbody>
              {renderRows(otherItems, 'otherLine_')}
            </tbody>
          </>
        )}
      </Table>
    );
  }
}

export default ProgramPanel;
